// Module
var code = `<table class="table table--wide">
  <thead>
  <th>No</th>
  <th>Text</th>
  <th>Status</th>
  <th>X</th>
  <th>Y</th>
  <th>Font size</th>
  <th>Action</th>
  </thead>
  <tbody>
  <tr ng-repeat="item in \$ctrl.getLabels()">
    <td class="print-details__control-number">
      {{\$index+1}}.
    </td>
    <td>
      <textarea
        ng-model="item.text"
        ng-change="\$ctrl.onChange()"
        maxlength="1024"
        cols="20"
      ></textarea>
    </td>
    <td>
      <select
        required
        class="print-details__control-input"
        ng-model="item.active"
        ng-change="\$ctrl.onChange()"
        boolean-options>
      </select>
    </td>
    <td>
      <glue-container append="'mm'">
        <input class="print-details__control-input"
               type="number"
               ng-model="item.x"
               ng-change="\$ctrl.onChange()"
               min="0"/>
      </glue-container>
    </td>
    <td>
      <glue-container append="'mm'">
        <input
          class="print-details__control-input"
          type="number"
          ng-model="item.y"
          ng-change="\$ctrl.onChange()"
          size="5"
          min="0"/>
      </glue-container>
    </td>
    <td>
      <input
        class="print-details__control-input"
        type="number"
        ng-model="item.fontSize"
        ng-change="\$ctrl.onChange()"
        size="5"
        min="0"/>
    </td>
    <td>
      <button type="button"
              class="btn btn-danger"
              ng-click="\$ctrl.removeLine(item) && \$ctrl.onChange()">
        Remove
      </button>
    </td>
  </tr>
  </tbody>
  <tfoot>
  <tr>
    <td></td>
    <td>
      <textarea
        ng-model="\$ctrl.newLabel.text"
        ng-change="\$ctrl.onChange()"
        maxlength="1024"
        cols="10"
      ></textarea>
    </td>
    <td>
      <select
        required
        class="print-details__control-input"
        ng-model="\$ctrl.newLabel.active"
        ng-change="\$ctrl.onChange()"
        boolean-options>
      </select>
    </td>
    <td>
      <glue-container append="'mm'">
        <input class="print-details__control-input"
               type="number"
               ng-model="\$ctrl.newLabel.x"
               ng-change="\$ctrl.onChange()"
               min="0"/>
      </glue-container>
    </td>
    <td>
      <glue-container append="'mm'">
        <input
          class="print-details__control-input"
          type="number"
          ng-model="\$ctrl.newLabel.y"
          ng-change="\$ctrl.onChange()"
          size="5"
          min="0"/>
      </glue-container>
    </td>
    <td>
      <input
        class="print-details__control-input"
        type="number"
        ng-model="\$ctrl.newLabel.fontSize"
        ng-change="\$ctrl.onChange()"
        size="5"
        min="0"/>
    </td>
    <td>
      <button type="button"
              class="btn btn-success"
              ng-disabled="!\$ctrl.newLabel.text"
              ng-click="\$ctrl.addLabel() && \$ctrl.onChange()">
        Add
      </button>
    </td>
  </tr>
  </tfoot>
</table>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/prints/prints-details-label-configuration.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;